import Accesses from "@components/Account/Artist/Accesses";

export default Accesses;
